<template>
  <div class="lock-component">
    <div v-if="isLitePlan" class="blur-overlay">
      <div class="lock-message-container">
        <div class="lock-message">
          <img src="@/assets/images/Lock.svg" alt="lock" class="lock-icon" />
          
          <div class="subscribe-row">
            <button
              class="subscribe-btn btn-secondary-theme-filled"
              @click.stop="$router.push('/pricing')"
            >
              Subscribe
            </button>
            <img
              src="@/assets/images/Youtube Icon.png"
              alt="YouTube"
              class="youtube-logo"
              @click="$emit('open-video')"
            />
          </div>

          <div class="features-list">
            <div class="list-center">
              <div><i class="el-icon-check"></i> Bundle of SEBI Research Analyst</div>
              <div><i class="el-icon-check"></i> 15+ Daily Strategies</div>
              <div><i class="el-icon-check"></i> Price estimate tracking of Advisory</div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LitePlanOverlay',
  computed: {
    isLitePlan() {
      const planDetails = JSON.parse(localStorage.getItem('plan_details'));
      return planDetails && planDetails.plan === 'Lite';
    },
  },
};
</script>

<style lang="scss" scoped>
.lock-component {
  position: relative;

  .blur-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    border-radius: 12px;
  }

  .lock-message-container {
    backdrop-filter: blur(8px);
    background-color: rgba(255, 255, 255, 0.6);
    padding: 10px 30px 0px 30px;
    border-radius: 12px;
    box-shadow: 0 0 12px rgba(0, 0, 0, 0.15);
    width: 100%;
    height: 135px;
    margin-top: -55px;
    text-align: center;
    margin-left: -5px;
  }

  .lock-message {
    color: #000;
  }

  .lock-icon {
    width: 20px;
  }

  .subscribe-row {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }

  .youtube-logo {
    width: 25px;
    height: 25px;
    cursor: pointer;
  }

  .subscribe-btn {
    width: 200px;
    border-radius: 10px;
    background: #2d2e8d;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
    font-size: 12px;
    font-weight: 500;
    text-transform: capitalize;
    cursor: pointer;
    color: #fff;
    border: none;
  }

  .features-list {
    display: flex;
    justify-content: center;
    margin-top: 5px;
    color: #2d2e8d;

    .list-center {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 240px;
    }

    .list-center div {
      display: flex;
      align-items: center;
      gap: 5px;
      // margin-bottom: 5px;
      font-size: 11px;
      font-weight: 600;
      text-align: left;
    }

    i {
      color: #000;
      font-size: 12px;
    }
  }

  /* Responsive styles */
  @media (max-width: 600px) {
    .lock-message-container {
      padding: 15px 10px 10px 10px;
      height: auto;
    }

    .features-list {
      // .list-center {
      //   width: 90%;
      // }

      .list-center div {
        font-size: 7px;
      }
    }

    .subscribe-btn {
      width: 150px;
      font-size: 11px;
    }

    .lock-icon {
    width: 15px;
  }
    .youtube-logo {
      width: 22px;
      height: 22px;
    }
  }
}
</style>